import { createI18n } from "vue-i18n";
import enEN from "./locales/en_EN.json";
import deDE from "./locales/de_DE.json";
import type { I18n } from "vue-i18n";
import { de, en } from "vuetify/locale";
import { buildI18nMessage } from "@polargold/pg-frontend-core";
import { AppLanguage } from "@/constants";

const messages = {
    de: buildI18nMessage(deDE, de),
    en: buildI18nMessage(enEN, en),
};

// noinspection JSDeprecatedSymbols
export const i18n: I18n = createI18n({
    legacy: false,
    locale: AppLanguage.English,
    fallbackLocale: AppLanguage.German,
    messages
});
